import { debounce } from './utils'

const collectionSearch = document.getElementById('collection-search')
const productsWrapper = document.querySelector('.archive-grid__content')

collectionSearch.addEventListener(
  'keydown',
  debounce(function (event) {
    const query = event.target.value.toLowerCase()
    productsWrapper.querySelectorAll('.card').forEach((product) => {
      const title = product
        .querySelector('.card__title')
        .textContent.toLowerCase()
      const description = product
        .querySelector('.card__description')
        .textContent.toLowerCase()

      if (title.indexOf(query) > -1 || description.indexOf(query) > -1)
        product.style.display = 'flex'
      else product.style.display = 'none'
    })
  }, 300)
)
